<div style="display: flex;flex-direction: row;flex-wrap: wrap;">
    <p class="item" [class.selected]="t==selected" *ngFor="let t of data.templates" (click)="select(t)"><span *ngIf="t.template_name_index">{{t.template_name_index}} - </span>{{t.template_name}}</p>
</div>

<p *ngIf="submitted&&selected==''" style="color: red;">Please choose a template</p>

<!-- <div style="display: flex;justify-content: center;">
    <button class="ok btn" (click)="ok()">Select</button>
    <button class="cancel btn" (click)="close()">Cancel</button>
</div> -->